var module = angular.module('octopusApp.infrastructure');

module.directive('octoPaginator', function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      collection: '=',
      contentType: '=',
      pageSelected: '=',
      isLoading: '=',
      showAsLoadMore: '=',
      loadMore: '=',
      loadAll: '='
    },
    templateUrl: 'infrastructure/directives/views/octo-paginator.html',
    link: function (scope, element, attrs) {
      scope.pages = [];
      scope.show = false;
      scope.skip = 0;

      var pagesToShow = 16;
      var halfPagesToShow = 8;

      scope.$watch('collection.Items', function (val, oldVal) {

        var coll = scope.collection;

        if (coll && coll.Links && coll.ItemsPerPage) {
          var totalPages = Math.ceil(coll.TotalResults / coll.ItemsPerPage);
          if (!scope.showAsLoadMore) {
            var pages = [];

            var currentPageIndex = 0;
            for (var j = 0; j < totalPages; j++) {
              if (coll.Links["Page." + j] === coll.Links["Page.Current"]) {
                currentPageIndex = j;
              }
            }
            var addPage = function (i, text) {
              pages.push({
                index: i,
                isActive: currentPageIndex === i,
                skip: i * coll.ItemsPerPage,
                number: text
              });
            };

            if (totalPages > 0) {
              addPage(0, "«");
            }

            var isStartCollapsed = false;
            var isEndCollapsed = false;
            for (var i = 0; i < totalPages; i++) {
              var skip = !(totalPages < pagesToShow || ((i - currentPageIndex) < halfPagesToShow && (i - currentPageIndex) > -halfPagesToShow));

              if (skip && i < currentPageIndex && !isStartCollapsed) {
                addPage(Math.max(currentPageIndex - pagesToShow, 0), "...");
                isStartCollapsed = true;
              }
              if (!skip) {
                addPage(i, (i + 1));
              }
              if (skip && i > currentPageIndex && !isEndCollapsed) {
                addPage(Math.min(currentPageIndex + pagesToShow, totalPages -1), "...");
                isEndCollapsed = true;
              }
            }

            if (totalPages > 0) {
              addPage(totalPages - 1, "»");
            }

            scope.show = totalPages > 1;
            scope.pages = pages;
          } else {
            if (coll.Links["Page.Next"] === undefined) {
              scope.show = false;
              scope.skip = 0;
            } else {
              scope.show = totalPages > 1;
              scope.skip = scope.skip + coll.ItemsPerPage;
            }
          }
        } else {
          scope.show = false;
          scope.pages = [];
        }
      });
    },
    controller: function($scope, octopusClient) {
      $scope.onPageSelected = function(skip, p) {
        if ($scope.pageSelected) {
          $scope.pageSelected(skip, p + 1);
        } else {
          if ($scope.collection && $scope.collection.Links){
            $scope.collection.Page = p;
            var pageLink = $scope.collection.Links["Page." + p];
            if($scope.contentType) {
              pageLink = pageLink + "&contentType=" + encodeURIComponent($scope.contentType);
            }
            var getPage = octopusClient.get(pageLink).then(function(newColl){
              $scope.collection.Items = newColl.Items;
              $scope.collection.Links = newColl.Links;
              $scope.collection.IsStale = newColl.IsStale;
              $scope.collection.ItemType = newColl.ItemType;
              $scope.collection.ItemsPerPage = newColl.ItemsPerPage;
            });
            if ($scope.isLoading) {
              $scope.isLoading.promise(getPage);
            }
          }
        }
      };

      $scope.onLoadMore = function (skip) {
        if ($scope.loadMore) {
          $scope.loadMore(skip);
        }
      };

      $scope.onLoadAll = function () {
        if ($scope.loadAll) {
          $scope.loadAll();
        }
      };
    }
  };
});







//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/octo_paginator.js
// module id = 676
// module chunks = 1